import React, { useContext } from 'react'
import { Context } from '../../context/SharedState'

export default function SkillsAndAcheivements(props) {

    const states = useContext(Context)

    const certificates = [
        {
            img: "https://i.ibb.co/8z6Q0xw/image.png",
            alt: "Infosys SpringBoard",
            animation: "flip-right"
        },
        {
            img: "https://i.ibb.co/DVb7NfZ/image.png",
            alt: "Coursera JS HTML CSS",
            animation: "flip-left"
        },
        {
            img: "https://i.ibb.co/vsfhVXZ/image.png",
            alt: "GDG Developers",
            animation: "flip-right"
        },
        {
            img: "https://i.ibb.co/WDcDRj8/image.png",
            alt: "Udemy Python Django",
            animation: "flip-down"
        },
        {
            img: "https://i.ibb.co/c28CyLG/image.png",
            alt: "Udemy Python In depth",
            animation: "slide-up"
        }
    ]

    return (
        <div className={`pb-4 ${props.mode === 'dark' ? 'bg-dark' : ''}`} data-bs-theme={props.mode}>

            {/* TITLE */}
            <div id="skills" className='madimi-one-regular text-center content-heading-text'>
                Skills and Achievements
            </div>

            <hr className="w-75 m-auto" />

            {/* MAIN CONTAINER */}
            <div className='container-fluid mt-4 px-3 px-md-4'>

                <div className='row g-4'>

                    {/* LEFT SIDE */}
                    <div
                        className='col-12 col-lg-4'
                        data-aos="fade-right"
                        data-aos-duration="2000"
                    >

                        {/* SKILLS */}
                        <div>
                            {states.skills.map((skill, idx) => (
                                <div
                                    className="progress mb-3 mb-md-4"
                                    style={{ height: '28px' }}
                                    key={idx}
                                >
                                    <div
                                        className={`progress-bar progress-bar-striped progress-bar-animated 
                    ${props.mode === 'dark' ? 'bg-dark' : `bg-${skill.color}`}`}
                                        style={{ width: `${skill.percentage}%`, fontSize: '12px' }}
                                    >
                                        {skill.title}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* TEXT */}
                        <p className='mt-4 mt-md-5 fs-6 fs-md-5 text-center px-2'>
                            I specialize in NestJS, React, ExpressJS, and MongoDB with a strong focus on MERN stack development.
                            I build scalable backend systems, clean APIs, and responsive UIs.
                            I enjoy solving real-world problems and continuously improving through hands-on projects and production experience.
                        </p>

                        {/* BUTTON */}
                        <div className='mb-4 d-flex justify-content-center'>
                            <a
                                className="button btn"
                                href="https://drive.google.com/file/d/1OfhdfY5wfwfz_mg5Vp6VXge7G-A_q7wt/view?usp=sharing"
                                target='_blank'
                                rel="noopener noreferrer"
                            >
                                <span className="button__text">Download Resume</span>
                                <span className="button__icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                                        <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                                        <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                                        <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
                                    </svg>
                                </span>
                            </a>
                        </div>

                    </div>

                    {/* RIGHT SIDE */}
                    <div className='col-12 col-lg-8'>

                        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">

                            {certificates.map((cert, index) => (
                                <div
                                    className="col"
                                    key={index}
                                    data-aos={cert.animation}
                                    data-aos-duration="2000"
                                >
                                    <div className="card h-100 border-0 shadow-sm">
                                        <img
                                            src={cert.img}
                                            alt={cert.alt}
                                            className="img-fluid"
                                            style={{
                                                height: '220px',
                                                objectFit: 'cover',
                                                width: '100%'
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}

                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
}